import { z } from 'zod'

/**
 * Dynamic feature flags schema - accepts any category/name structure from API.
 * Structure: { category: { flagName: boolean, ... }, ... }
 */
export const FeatureFlagsSchema = z.record(z.string(), z.record(z.string(), z.boolean()))

export type FeatureFlags = z.infer<typeof FeatureFlagsSchema>

/**
 * Empty default - flags will be loaded from API
 */
export const defaultFeatureFlags: FeatureFlags = {}
